import { RegistrationPageContent } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const RegistrationPage = () => {
  return (
    <PageProvider>
      <RegistrationPageContent />
    </PageProvider>
  );
};
